import { ViewerApi } from "@bronte/viewer-api/src/main";

import { getTocForWeb } from "./getTocForWeb";
import { getTocForMobile } from "./getTocForMobile";
import { Toc } from "./types";

export const getCoursewareStructure = (
  viewerApi: ViewerApi,
  isOfflinePackage: boolean,
): Promise<() => Toc> => {
  return isOfflinePackage ? getTocForMobile(viewerApi) : getTocForWeb(viewerApi);
};
